/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";


const include = `sensor,eventCode, eventType,remanentLife, advanceNotificationPeriod,  startDate, endDate, threshold, predictedWallThickness,  sensor.isRealSensor, sensor.uninstalled, alertStartDate, alertEndDate, category, comments, status, sensor.averageCorrosionRatePredictionFromLiveModel, sensor.averageMeasuredCorrosionRate, measuredWallThicknessLoss, predictedWallThicknessLoss, averageCRValue, sensor.alertThreshold, sensor.site, sensor.cmLocation, sensor.cmLocation.shortName, sensor.cmLocation.equipment.subsystem.system.shortName`;

function useGetAlertsReportData(currentPage, pageSize, order_by, order_dir, filter, refreshToggle) {
    const [data, setData] = useState({
        alertsList: [],
        alertsCount: 0
    });
    let offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        setLoading(true);
        Promise.all([
            azureFetch("corrosion-rate-alerts-report-data", {
                    limit: pageSize,
                    where_clause: filter,
                    offset,
                    order_dir: order_dir,
                    order_by: order_by,
                } ),
            azureFetch('alerts-report-count', {
                where_clause: filter,
            })
        ]).then(([alerts_list, alerts_count]) => {
            setData({
                alertsList: alerts_list?.data,
                alertsCount: alerts_count?.data?.TotalRows,
            });
        })
        .catch((error) => {
            console.error(error);
            toast.error(`Cannot fetch Corrosion Alerts List`);
            setError(error);
        }).finally(() => {
            setLoading(false);
        });

    }, [currentPage, order_by, order_dir, filter, refreshToggle]);

    return { data, loading, error };
}


export default useGetAlertsReportData;